import React, { useState, useEffect } from "react";
import { putData } from "../../FetchNodeServices";

const ForgetPasswordForm = ({ setShowForgetPasswordForm }) => {
  const [emailId, setEmailId] = useState("");
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

  useEffect(() => {
    if (error) {
      setTimeout(() => {
        setError(null);
      }, 5000); // hide error message after 5 seconds
    }

    if (success) {
      setTimeout(() => {
        setSuccess(null);
      }, 5000); // hide success message after 5 seconds
    }
  }, [error, success]);

  const handleSubmit = async (event) => {
    try {
      const response = await putData("users/forgot-password-check?email=" + emailId);
      console.log("test", response);
      // const data = await response.json();
      if (response) {
        // setSuccess("Password reset email sent successfully!");
        setSuccess(response);
      } else {
        setError("Error sending password reset email. Please try again.");
      }
    } catch (error) {
      setError("Error sending password reset email. Please try again.");
    }
  };

  const handleBackToLogin = () => {
    setShowForgetPasswordForm(false);
  };

  return (
    <form>
      <div className="form-group mt-4 mb-3 position-relative">
        <label htmlFor="" className="fs-16 lh-15 mb-2 ps-3 d-block ">
          Forget Password
        </label>
        <input
          type="email"
          className="form-control"
          id="email"
          autoComplete="off"
          placeholder="Enter Email Address"
          value={emailId}
          onChange={(event) => setEmailId(event.target.value)}
          required
        />
      </div>
      <div className="text-end">
        <a href="#" className="fs-14 lh-24" onClick={() => handleBackToLogin()}>
          Back to Login
        </a>
      </div>
      {error && <div className="alert alert-danger">{error}</div>}
      {success && <div className="alert alert-success">{success}</div>}
      <button type="button" className="btn btn-success w-100 mt-3 mb-2" onClick={() => handleSubmit()}>
        Send password reset email
      </button>
    </form>
  );
};

export default ForgetPasswordForm;
